import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Layout from "./components/Layout";
import SplashScreen from "./components/SplashScreen";
import Landing from "./pages/Landing";
import Sign from "./pages/Sign";
import Gallery from "./pages/Gallery";
import EntryDetail from "./pages/EntryDetail";
import NestLanding from "./pages/NestLanding";
import Admin from "./pages/Admin";
import CheckIn from "./pages/CheckIn";

function App() {
  return (
    <div className="App">
      <SplashScreen />
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Landing />} />
            <Route path="/sign" element={<Sign />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/gallery/:id" element={<EntryDetail />} />
            <Route path="/nest/:nestId" element={<NestLanding />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/checkin/:slug" element={<CheckIn />} />
            <Route path="/c/:slug" element={<CheckIn />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
